(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-line-item"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__cartLineItemQuantityBound) return;
    window.__cartLineItemQuantityBound = true;

    const COALESCE_MS = 300;
    const pending = new WeakMap();

    document.addEventListener('quantity:change', (event) => {
      const picker = event.target;
      if (!picker || typeof picker.closest !== 'function') return;

      const row = picker.closest('[data-cart-line-item]');
      if (!row) return;

      const cartItems = row.closest('cart-items');
      if (!cartItems || typeof cartItems.updateQuantity !== 'function') return;

      const line = row.dataset.index;
      const quantity = event.detail.value;
      const name = event.detail.name;
      const target = picker.querySelector('[data-quantity-input]') || picker;

      // cart.js's error path reads data-index off the TARGET (legacy markup
      // kept it on the input); the picker carries it on its root. Mirror it
      // onto the input so hideLoader/setValidity keep working on a 422.
      if (target !== picker && !target.hasAttribute('data-index')) {
        target.setAttribute('data-index', line);
        const vid = picker.getAttribute('data-quantity-variant-id');
        if (vid) target.setAttribute('data-quantity-variant-id', vid);
        const cartQty = picker.getAttribute('data-cart-quantity');
        if (cartQty) target.setAttribute('data-cart-quantity', cartQty);
      }

      // A state marker only, and deliberately not styled. The attribute lives
      // for the 300ms coalescing window, which is exactly the window the
      // shopper is still tapping in, so anything that takes pointer events
      // away here cancels the taps the timer is meant to gather up. Measured:
      // with `pointer-events: none` on this attribute, five fast real taps
      // advanced the picker by ONE while five synthetic clicks, which bypass
      // pointer-events, advanced it by five and still sent one request. The
      // in-flight lock is `.btn--loading` on the loader, which cart.js owns.
      row.setAttribute('data-cart-line-item-pending', '');

      clearTimeout(pending.get(row));
      pending.set(
        row,
        setTimeout(() => {
          pending.delete(row);
          row.removeAttribute('data-cart-line-item-pending');
          cartItems.updateQuantity(line, quantity, name, target);
        }, COALESCE_MS)
      );
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["checkbox"] && !Shopify.designMode) return;
  try {
    (function () {
    function applyIndeterminate(root) {
      var scope = root || document;
      var boxes = scope.querySelectorAll('input[type="checkbox"][data-indeterminate="true"]');
      for (var i = 0; i < boxes.length; i++) {
        boxes[i].indeterminate = true;
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        applyIndeterminate(document);
      });
    } else {
      applyIndeterminate(document);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delivery-estimate-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__oliveGroveDeliveryEstimateInit) return;
    window.__oliveGroveDeliveryEstimateInit = true;

    const KEY = 'olive-grove:delivery-locality';
    const api = () => window.StoreAvailability;

    // Guards a slow response for an abandoned query from overwriting a newer one.
    let seq = 0;

    const money = (value) => {
      // Prices are decimal strings on the metaobject ("227.0"). Format with the theme's
      // money helper when available so currency presentation stays consistent.
      const n = Number(value);
      if (!Number.isFinite(n)) return '';
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(Math.round(n * 100), window.FoxTheme?.moneyFormat);
      }
      return n.toLocaleString(undefined, { style: 'currency', currency: 'AUD' });
    };

    // The locale string carries a double-brace `locality` placeholder. The needle is
    // built by concatenation so no literal Liquid tag appears in this JS block: Theme
    // Check flags one as a variable (StaticStylesheetAndJavascriptTags), and any step
    // that DID evaluate it would substitute an empty string and silently break every
    // locality line.
    const LOCALITY_TOKEN = '{' + '{ locality }' + '}';

    const esc = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
      }[c]));

    function els(drawer) {
      return {
        body: drawer.querySelector('.de-drawer__body'),
        input: drawer.querySelector('input[name="delivery_estimate_postcode"]'),
        status: drawer.querySelector('[data-de-status]'),
        suggestions: drawer.querySelector('[data-de-suggestions]'),
        result: drawer.querySelector('[data-de-result]'),
        locality: drawer.querySelector('[data-de-locality]'),
        price: drawer.querySelector('[data-de-price]'),
        note: drawer.querySelector('[data-de-note]'),
      };
    }

    // States Olive Grove does not deliver to (Productive #338). Checkout refuses the same
    // states because they are excluded from the Domestic shipping zone in Admin — keep
    // this list and that zone in step.
    const UNSERVICED_STATES = new Set(['NT', 'WA', 'SA', 'TAS']);
    const undeliverable = (match) =>
      !!match && UNSERVICED_STATES.has(String(match.state || '').toUpperCase());

    function priceCopy(body, match) {
      if (undeliverable(match)) return body.dataset.undeliverable || '';
      return match.price != null ? money(match.price) : body.dataset.quote || '';
    }

    function noteCopy(body, match) {
      if (undeliverable(match)) return body.dataset.undeliverableNote || '';
      return match.price != null ? '' : body.dataset.quoteNote || '';
    }

    function reset(drawer) {
      const el = els(drawer);
      if (el.status) el.status.textContent = '';
      if (el.result) el.result.hidden = true;
    }

    /**
     * Paint a resolved match, persist it, and update the availability block.
     *
     * Three distinct outcomes, deliberately NOT collapsed:
     *   price present            -> show the price
     *   price null               -> "Delivery quote required" (a real, priced-out area)
     *   priceUnavailable === true -> lookup FAILED; show a retry, never "quote required"
     */
    function applyMatch(drawer, match) {
      const el = els(drawer);
      if (!el.body) return;

      if (el.status) el.status.textContent = '';

      if (match.priceUnavailable) {
        if (el.status) el.status.textContent = el.body.dataset.unavailable || '';
        if (el.result) el.result.hidden = true;
        return;
      }

      const tpl = el.body.dataset.deliversTo || '';
      if (el.locality) el.locality.textContent = tpl.replace(LOCALITY_TOKEN, match.label || '');

      if (el.price) el.price.textContent = priceCopy(el.body, match);
      if (el.note) el.note.textContent = noteCopy(el.body, match);
      if (el.result) el.result.hidden = false;

      // Persist so the choice survives navigation, and mirror it onto the PDP
      // availability block so the shopper sees it without reopening the drawer.
      try {
        localStorage.setItem(KEY, JSON.stringify(match));
      } catch (e) {
        /* private mode - the drawer still works, it just will not remember */
      }
      paintBlock(match);
    }

    /**
     * Rewrite the PDP availability block's delivery column in place.
     *
     * The block's default copy names a PLACEHOLDER locality ("Delivery available to
     * 2481" / "Est. shipping $89"). Appending the resolved estimate below it left two
     * contradicting answers on screen, so the status and price lines are REPLACED.
     *
     * Optional by design: the block may not be on the template, in which case the
     * drawer still functions standalone.
     */
    function paintBlock(match) {
      const status = document.querySelector('[data-availability-delivery-status]');
      const price = document.querySelector('[data-availability-delivery-price]');
      const body = document.querySelector('.de-drawer__body');
      if (!body || (!status && !price)) return;

      // A failed lookup must not overwrite good copy with a wrong answer.
      if (match.priceUnavailable) return;

      if (status) {
        status.textContent = (body.dataset.deliversTo || '').replace(
          LOCALITY_TOKEN,
          match.label || ''
        );
        status.hidden = false;
      }
      // The status dot turns red for an unserviced state and back to green otherwise, so a
      // later deliverable lookup never leaves a stale red dot beside a price. The dot is a
      // SIBLING of the body holding these lines, so the hop is up to .pdp-availability__col
      // — Olive Grove has no .pdp-availability__item wrapper (Eureka does).
      const dot = (status || price).closest('.pdp-availability__col')?.querySelector('.pdp-availability__dot');
      if (dot) dot.classList.toggle('pdp-availability__dot--unavailable', undeliverable(match));
      if (price) {
        // An unserviced state gets the full sentence here: the block has no note line, and
        // "Delivery not available" alone would not tell the shopper what to do instead.
        if (undeliverable(match)) {
          price.textContent = body.dataset.undeliverableNote || '';
        } else {
          price.textContent = match.price != null ? money(match.price) : body.dataset.quote || '';
        }
        price.hidden = false;
      }
    }

    /**
     * Fetch and render type-ahead suggestions.
     *
     * One session token spans every keystroke of a search plus the final resolution, so
     * a shopper typing "Newtown" costs ONE billable session rather than seven requests.
     * Minted lazily and cleared on selection.
     */
    async function suggest(drawer, term) {
      const el = els(drawer);
      const value = (term || '').trim();
      if (!el.suggestions) return;

      const sa = api();
      if (!sa || !sa.geocodeConfigured || value.length < 2) {
        hideSuggestions(drawer);
        return;
      }

      if (!drawer.__deSession) drawer.__deSession = sa.newSession();

      const mine = ++seq;
      const out = await sa.suggest(value, drawer.__deSession);
      if (mine !== seq) return;

      if (!out.ok || !out.suggestions.length) {
        hideSuggestions(drawer);
        return;
      }

      el.suggestions.textContent = '';
      out.suggestions.forEach((sug, i) => {
        const li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        li.innerHTML = `
          <button type="button" class="de-drawer__suggestion" role="option"
                  aria-selected="false" data-de-suggestion="${i}">
            ${esc(sug.label)}
          </button>
        `;
        el.suggestions.appendChild(li);
      });
      drawer.__deSuggestions = out.suggestions;
      el.suggestions.hidden = false;
    }

    function hideSuggestions(drawer) {
      const el = els(drawer);
      if (!el.suggestions) return;
      el.suggestions.hidden = true;
      el.suggestions.textContent = '';
      drawer.__deSuggestions = null;
    }

    /**
     * Resolve a picked suggestion into a priced locality.
     *
     * Only a SELECTED suggestion can produce an estimate — that is what guarantees the
     * rate key belongs to a place the shopper actually chose.
     */
    async function choose(drawer, index) {
      const el = els(drawer);
      const sug = (drawer.__deSuggestions || [])[index];
      if (!sug || !el.body) return;

      hideSuggestions(drawer);
      if (el.input) {
        el.input.value = sug.label;
        toggleClear(el.input);
      }
      if (el.status) el.status.textContent = el.body.dataset.searching || '';

      const sa = api();
      const mine = ++seq;
      const out = await sa.place(sug.placeId, drawer.__deSession);
      if (mine !== seq) return;

      // The session ends at resolution; the next search mints a fresh token.
      drawer.__deSession = null;

      if (!out.ok || !out.match) {
        if (el.status) {
          el.status.textContent = out.ok
            ? el.body.dataset.noResults || ''
            : el.body.dataset.unavailable || '';
        }
        return;
      }

      drawer.__deResolvedFor = sug.label;
      applyMatch(drawer, out.match);
    }

    /**
     * Confirm handler.
     *
     * An estimate can ONLY come from a selected suggestion, so Confirm has three jobs
     * and never guesses:
     *   - estimate already showing for this input -> close (submit closes, per the brief)
     *   - exactly one suggestion open             -> take it, resolve, close
     *   - otherwise                               -> prompt to pick, keep the drawer open
     *
     * Closing while suggestions are open would discard the pending choice and leave the
     * availability block stale.
     */
    async function confirm(drawer) {
      const el = els(drawer);
      if (!el.input) return;

      const term = el.input.value.trim();
      const showing = el.result && !el.result.hidden;
      if (showing && drawer.__deResolvedFor === term) {
        close(drawer);
        return;
      }

      const open = drawer.__deSuggestions || [];
      if (open.length === 1) {
        await choose(drawer, 0);
        const after = els(drawer);
        if (after.result && !after.result.hidden) close(drawer);
        return;
      }

      // Nothing selected: ask rather than geocoding free text, which is exactly the
      // silent-wrong-suburb case this flow exists to prevent.
      if (el.status && el.body) {
        el.status.textContent = open.length
          ? el.body.dataset.chooseHelp || ''
          : el.body.dataset.noResults || '';
      }
      if (open.length) el.input.focus();
    }

    function close(drawer) {
      // basic-modal owns open/close; drive it through its own close control so focus
      // return and the overlay teardown behave exactly as they do elsewhere.
      const btn = drawer.querySelector('.drawer__close-btn');
      if (btn) btn.click();
      else drawer.hidden = true;
    }

    function toggleClear(input) {
      const clear = input.closest('.de-drawer__field')?.querySelector('[data-de-clear]');
      if (clear) clear.hidden = !input.value.trim();
    }

    document.addEventListener('DOMContentLoaded', () => {
      let saved = null;
      try {
        saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      } catch (e) {
        saved = null;
      }
      if (!saved) return;

      document.querySelectorAll('input[name="delivery_estimate_postcode"]').forEach((input) => {
        if (!input.value) input.value = saved.label || saved.postcode || saved.suburb || '';
        toggleClear(input);
      });
      // Repaint the last estimate without a network call.
      document.querySelectorAll('.de-drawer').forEach((drawer) => {
        const el = els(drawer);
        if (!el.body) return;
        const tpl = el.body.dataset.deliversTo || '';
        if (el.locality) el.locality.textContent = tpl.replace(LOCALITY_TOKEN, saved.label || '');
        if (el.price) el.price.textContent = priceCopy(el.body, saved);
        if (el.note) el.note.textContent = noteCopy(el.body, saved);
        if (el.result) el.result.hidden = false;
        // The restored estimate matches the restored input, so Confirm should close
        // rather than re-prompt.
        drawer.__deResolvedFor = saved.label || '';
      });
      paintBlock(saved);
    });

    document.addEventListener('click', (event) => {
      const drawer = event.target.closest('.de-drawer');
      if (!drawer) return;

      if (event.target.closest('[data-de-confirm]')) {
        confirm(drawer);
        return;
      }

      const suggestion = event.target.closest('[data-de-suggestion]');
      if (suggestion) {
        // Selecting resolves and closes: the shopper has disambiguated, so the estimate
        // is final ("submitting the modal closes it and updates the block").
        choose(drawer, Number(suggestion.dataset.deSuggestion)).then(() => {
          const after = els(drawer);
          if (after.result && !after.result.hidden) close(drawer);
        });
        return;
      }

      if (event.target.closest('[data-de-clear]')) {
        const el = els(drawer);
        if (el.input) {
          el.input.value = '';
          toggleClear(el.input);
          el.input.focus();
        }
        hideSuggestions(drawer);
        drawer.__deSession = null;
        drawer.__deResolvedFor = null;
        reset(drawer);
        return;
      }

      // A click anywhere else in the drawer dismisses an open suggestion list.
      if (!event.target.closest('.de-drawer__field')) hideSuggestions(drawer);
    });

    // Debounced type-ahead. 250ms balances responsiveness against billed calls; the
    // session token means a whole search is charged once regardless of keystrokes.
    let debounce;
    document.addEventListener('input', (event) => {
      const input = event.target.closest('input[name="delivery_estimate_postcode"]');
      if (!input) return;
      const drawer = input.closest('.de-drawer');
      if (!drawer) return;
      toggleClear(input);
      // Typing invalidates any resolved estimate - it no longer matches the input.
      drawer.__deResolvedFor = null;
      clearTimeout(debounce);
      debounce = setTimeout(() => suggest(drawer, input.value), 250);
    });

    document.addEventListener('keydown', (event) => {
      // Scope to the FIELD, not the input: arrowing into the list moves focus onto a
      // suggestion button, and keying off the input alone would strand the shopper
      // there with dead arrow keys.
      const field = event.target.closest('.de-drawer__field');
      if (!field) return;
      const drawer = field.closest('.de-drawer');
      if (!drawer) return;

      const options = [...drawer.querySelectorAll('[data-de-suggestion]')];

      // Arrow keys move through the list; Enter takes the highlighted option. Without
      // this the listbox is mouse-only, which fails keyboard and screen-reader use.
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
        event.preventDefault();
        const current = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
        const next =
          event.key === 'ArrowDown'
            ? Math.min(current + 1, options.length - 1)
            : Math.max(current - 1, 0);
        options.forEach((o, i) => o.setAttribute('aria-selected', String(i === next)));
        options[next].focus();
        return;
      }

      if (event.key === 'Escape') {
        hideSuggestions(drawer);
        const el = els(drawer);
        if (el.input) el.input.focus();
        return;
      }

      if (event.key === 'Enter') {
        // On a suggestion button, let the native click fire - the click handler already
        // resolves it, and intercepting here would double-resolve.
        if (event.target.closest('[data-de-suggestion]')) return;
        event.preventDefault();
        const highlighted = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
        if (highlighted >= 0) {
          choose(drawer, highlighted).then(() => {
            const after = els(drawer);
            if (after.result && !after.result.hidden) close(drawer);
          });
          return;
        }
        confirm(drawer);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-demo-pagination"] && !Shopify.designMode) return;
  try {
    // Puts the real runtime loading class on the load-more button in the loading
  // specimen, so that cell proves the component's own selector works rather
  // than a CSS lookalike. A static override would also have had to out-specify
  // the component's base rule, which hides the ring by default.
  document.addEventListener('DOMContentLoaded', function () {
    var frame = document.querySelector('[data-ds-case="load_more_loading"]');
    if (!frame) return;
    var button = frame.querySelector('.pagination__load-more-btn');
    if (button) button.classList.add('btn--loading');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-demo-toast"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const control = event.target.closest('[data-toastb-action]');
    if (!control) {
      return;
    }

    const row = control.closest('[data-probe="toast-lifecycle"]');
    if (!row) {
      return;
    }

    const stage = row.querySelector('[data-toastb-stage]');
    const action = control.dataset.toastbAction;

    const toast = stage.querySelector('toast-banner');
    if (!toast) {
      return;
    }

    if (action === 'floating') {
      // Clone the real server-rendered toast rather than hand-writing markup,
      // so the floating demo cannot drift from the snippet's own output.
      const floater = toast.cloneNode(true);
      floater.removeAttribute('id');
      floater.dataset.state = 'enter';
      floater.dataset.duration = '4000';
      floater.setAttribute('data-floating', '');
      const live = floater.querySelector('[data-toast-announce]');
      if (live) {
        live.textContent = '';
      }
      document.body.appendChild(floater);
      window.requestAnimationFrame(function () {
        floater.dataset.state = 'visible';
      });
      return;
    }

    toast.dataset.state = action;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facet-sort-drawer"] && !Shopify.designMode) return;
  try {
    class SortDrawer extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.sort-drawer__trigger');
      this.current = this.querySelector('[data-sort-drawer-current]');
      this.drawer = this.querySelector('drawer-component#SortDrawer');
      if (!this.drawer) return;

      this.bindOptions();

      this.onRerendered = this.sync.bind(this);
      document.addEventListener('collection:rerendered', this.onRerendered);
    }

    disconnectedCallback() {
      document.removeEventListener('collection:rerendered', this.onRerendered);
    }

    /* Rows are bound individually, so a host that rewrites the list (tagalys-facets.js
       paints the Tagalys sort options into it) calls refresh() to re-read and re-bind. */
    bindOptions() {
      this.options = Array.from(this.querySelectorAll('.sort-drawer__option'));
      this.options.forEach((option) => {
        option.addEventListener('click', () => this.select(option));
      });
    }

    refresh() {
      this.bindOptions();
      this.sync();
    }

    get native() {
      return document.getElementById('SortBy');
    }

    select(option) {
      const value = option.getAttribute('data-value');
      this.options.forEach((o) => o.setAttribute('aria-checked', o === option ? 'true' : 'false'));
      if (this.current) {
        const label = option.querySelector('.sort-drawer__option-label');
        this.current.textContent = label ? label.textContent : '';
      }
      const native = this.native;
      if (native && native.value !== value) {
        native.value = value;
        native.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.drawer.hide();
    }

    sync() {
      const native = this.native;
      if (!native) return;
      const value = native.value;
      this.options.forEach((o) => {
        const match = o.getAttribute('data-value') === value;
        o.setAttribute('aria-checked', match ? 'true' : 'false');
        if (match && this.current) {
          const label = o.querySelector('.sort-drawer__option-label');
          this.current.textContent = label ? label.textContent : '';
        }
      });
    }
  }

  if (!customElements.get('sort-drawer')) {
    customElements.define('sort-drawer', SortDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facet-sort-menu"] && !Shopify.designMode) return;
  try {
    class SortMenu extends HTMLElement {
    connectedCallback() {
      this.native = this.querySelector('[data-sort-native]');
      this.trigger = this.querySelector('[data-sort-trigger]');
      this.popoverEl = this.querySelector('[data-sort-popover]');
      this.list = this.querySelector('[data-sort-list]');
      if (!this.native || !this.trigger || !this.popoverEl || !this.list) return;

      this.currentLabel = this.querySelector('[data-sort-current]');
      this.items = Array.from(this.querySelectorAll('.sort-menu__item'));
      this.activeIndex = -1;

      this.classList.add('is-enhanced');
      this.trigger.hidden = false;
      this.popoverEl.hidden = true;
      this.setAttribute('data-state', 'closed');

      this.onDocClick = this.onDocClick.bind(this);
      this.trigger.addEventListener('click', () => this.toggle());
      this.trigger.addEventListener('keydown', (e) => this.onTriggerKey(e));
      this.list.addEventListener('keydown', (e) => this.onListKey(e));
      this.bindItems();
    }

    /* Rows are bound individually, so a host that rewrites the list (tagalys-facets.js
       paints the Tagalys sort options into it) calls refresh() to re-read and re-bind. */
    bindItems() {
      this.items = Array.from(this.querySelectorAll('.sort-menu__item'));
      this.items.forEach((item, i) => {
        item.addEventListener('click', () => this.select(i));
        item.addEventListener('mousemove', () => this.setActive(i));
      });
    }

    refresh() {
      if (!this.list) return;
      this.activeIndex = -1;
      this.bindItems();
      const selected = this.items.find((i) => i.classList.contains('is-selected'));
      if (selected && this.currentLabel) {
        const label = selected.querySelector('.sort-menu__item-label');
        this.currentLabel.textContent = label ? label.textContent : '';
      }
    }

    get isOpen() {
      return this.getAttribute('data-state') === 'open';
    }

    open() {
      this.setAttribute('data-state', 'open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.popoverEl.hidden = false;
      document.addEventListener('click', this.onDocClick);
      const current = this.items.findIndex((i) => i.classList.contains('is-selected'));
      this.setActive(current > -1 ? current : 0);
      window.requestAnimationFrame(() => this.list.focus());
    }

    close(returnFocus) {
      this.setAttribute('data-state', 'closed');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.popoverEl.hidden = true;
      document.removeEventListener('click', this.onDocClick);
      if (returnFocus) this.trigger.focus();
    }

    toggle() {
      if (this.isOpen) {
        this.close(true);
      } else {
        this.open();
      }
    }

    onDocClick(e) {
      if (!this.contains(e.target)) this.close(false);
    }

    setActive(index) {
      this.items.forEach((i) => i.classList.remove('is-active'));
      this.activeIndex = index;
      const item = this.items[index];
      if (item) {
        item.classList.add('is-active');
        this.list.setAttribute('aria-activedescendant', item.id);
        item.scrollIntoView({ block: 'nearest' });
      }
    }

    move(step) {
      if (!this.items.length) return;
      let next = this.activeIndex + step;
      if (next < 0) next = this.items.length - 1;
      if (next > this.items.length - 1) next = 0;
      this.setActive(next);
    }

    select(index) {
      const item = this.items[index];
      if (!item) return;
      const value = item.getAttribute('data-value');
      this.items.forEach((i) => {
        i.classList.remove('is-selected');
        i.setAttribute('aria-selected', 'false');
      });
      item.classList.add('is-selected');
      item.setAttribute('aria-selected', 'true');
      if (this.currentLabel) {
        const label = item.querySelector('.sort-menu__item-label');
        this.currentLabel.textContent = label ? label.textContent : '';
      }
      if (this.native.value !== value) {
        this.native.value = value;
        this.native.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.close(true);
    }

    onTriggerKey(e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.open();
      }
    }

    onListKey(e) {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          this.move(1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          this.move(-1);
          break;
        case 'Home':
          e.preventDefault();
          this.setActive(0);
          break;
        case 'End':
          e.preventDefault();
          this.setActive(this.items.length - 1);
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (this.activeIndex > -1) this.select(this.activeIndex);
          break;
        case 'Escape':
          e.preventDefault();
          this.close(true);
          break;
        case 'Tab':
          this.close(false);
          break;
        default:
          break;
      }
    }
  }

  if (!customElements.get('sort-menu')) {
    customElements.define('sort-menu', SortMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["faq-row"] && !Shopify.designMode) return;
  try {
    if (!window.__faqItemSummarySync) {
    window.__faqItemSummarySync = true;
    document.addEventListener(
      'toggle',
      function (event) {
        var details = event.target;
        if (!details.matches || !details.matches('.faq-item__details')) return;
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["find-in-store-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__oliveGroveFindInStoreInit) return;
    window.__oliveGroveFindInStoreInit = true;

    const KEY = 'olive-grove:fis-postcode';
    // The resolved coordinates for KEY. Persisted so a returning shopper's distances
    // survive a reload without re-billing a geocode round-trip.
    const ORIGIN_KEY = 'olive-grove:fis-origin';
    const STORE_KEY = 'olive-grove:my-store';
    // The store NAME is persisted alongside the id so the availability block can be
    // repainted on load without waiting for (or paying for) a Storefront round-trip.
    const STORE_NAME_KEY = 'olive-grove:my-store-name';
    const SHOW = 5;

    // The locale string carries a double-brace `store` placeholder. Built by
    // concatenation so no literal Liquid tag appears in this JS block — Theme Check
    // flags one as a variable (StaticStylesheetAndJavascriptTags), and any step that
    // evaluated it would substitute an empty string.
    const STORE_TOKEN = '{' + '{ store }' + '}';
    const TERM_TOKEN = '{' + '{ term }' + '}';
    const DISTANCE_TOKEN = '{' + '{ distance }' + '}';

    const myStore = () => localStorage.getItem(STORE_KEY);
    const api = () => window.StoreAvailability;

    // Origin for the proximity sort. Set by the locate button (real position) or by a
    // PICKED suggestion. null = let Shopify return its default order.
    let origin = null;
    // The label the current origin came from, so the heading names the place actually
    // sorted by rather than whatever is currently typed in the field.
    let originTerm = null;
    // Guard slow responses for abandoned queries overwriting newer ones. Separate
    // counters: suggestions and availability are independent request streams, and
    // sharing one would let a suggestion fetch cancel a store lookup.
    let requestSeq = 0;
    let suggestSeq = 0;

    function paintMine(drawer) {
      const mine = myStore();
      drawer.querySelectorAll('[data-store]').forEach((el) => {
        const isMine = !!mine && el.dataset.handle === mine;
        el.classList.toggle('fis-drawer__store--mine', isMine);
        const flag = el.querySelector('[data-store-flag]');
        if (flag) flag.hidden = !isMine;
        const set = el.querySelector('[data-store-set]');
        if (set) set.disabled = isMine;
      });
    }

    /**
     * Rewrite the PDP availability block's pickup status line in place.
     *
     * The block default names a PLACEHOLDER store ("Pickup available at Byron Bay"), so
     * once the shopper picks their store it is REPLACED rather than left to contradict
     * the choice. Mirrors what the delivery drawer does to its own column.
     *
     * Optional by design: the block may not be on the template.
     */
    function paintPickupBlock(storeName) {
      const target = document.querySelector('[data-availability-pickup-status]');
      const body = document.querySelector('.fis-drawer__body');
      if (!target || !body || !storeName) return;
      target.textContent = (body.dataset.pickupAt || '').replace(STORE_TOKEN, storeName);
      target.hidden = false;
    }

    const esc = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
      }[c]));

    /**
     * Display form for a phone number. The API returns E.164 ("+61266029420"), which
     * reads as an undifferentiated digit run; the design shows "02 6602 9420".
     *
     * Only AU numbers are reshaped — anything else is returned untouched rather than
     * mangled into a format it does not use. The tel: href keeps the raw E.164, which
     * is the most reliable thing to hand a dialler.
     */
    function phoneLabel(raw) {
      const s = String(raw || '').replace(/\s+/g, '');
      // +61 4XX XXX XXX -> 04XX XXX XXX (mobile)
      const mob = s.match(/^\+?61(4\d{2})(\d{3})(\d{3})$/);
      if (mob) return `0${mob[1]} ${mob[2]} ${mob[3]}`;
      // +61 X XXXX XXXX -> 0X XXXX XXXX (landline)
      const land = s.match(/^\+?61([2378])(\d{4})(\d{4})$/);
      if (land) return `0${land[1]} ${land[2]} ${land[3]}`;
      return raw;
    }

    /**
     * Great-circle distance in km between two {latitude, longitude} pairs.
     *
     * The design's top-right slot shows "0.8km", and `storeAvailability` returns each
     * location's coordinates, so this is computed rather than approximated. Only
     * meaningful once an ORIGIN exists (a picked locality or the device position) —
     * without one there is nothing to measure from and the slot falls back to pickUpTime.
     */
    function distanceKm(origin, addr) {
      // `Number(null)` is 0 and `Number('')` is 0, both of which are finite - so a
      // location with no coordinates would measure against (0, 0) in the Gulf of Guinea
      // and report a confident 15,000km. Reject the empty cases BEFORE coercing.
      const raw = (v) => (v === null || v === undefined || v === '' ? NaN : Number(v));
      const lat2 = raw(addr && addr.latitude);
      const lon2 = raw(addr && addr.longitude);
      if (!origin || !Number.isFinite(lat2) || !Number.isFinite(lon2)) return null;
      const R = 6371;
      const rad = (deg) => (deg * Math.PI) / 180;
      const dLat = rad(lat2 - origin.latitude);
      const dLon = rad(lon2 - origin.longitude);
      const h =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(rad(origin.latitude)) * Math.cos(rad(lat2)) * Math.sin(dLon / 2) ** 2;
      return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
    }

    /** Design shows one decimal under 10km ("0.8km"), whole km above ("11km"). */
    function distanceLabel(km, template) {
      if (km == null) return null;
      const value = km < 10 ? km.toFixed(1) : String(Math.round(km));
      return (template || '').replace(DISTANCE_TOKEN, value);
    }

    /**
     * Location names the merchant marked as warehouses, normalised for comparison.
     * One per line in the setting; commas are tolerated too. Matched on the exact
     * location name (case-insensitive) rather than a "warehouse" substring, so a
     * showroom that happens to say "Warehouse Outlet" is not silently demoted.
     */
    function warehouseNames(raw) {
      return new Set(
        String(raw || '')
          .split(/\r?\n|,/)
          .map((n) => n.trim().toLowerCase())
          .filter(Boolean)
      );
    }

    /** One store row. */
    function row(node, d) {
      const loc = node.location || {};
      const a = loc.address || {};
      const street = [a.address1, a.address2].filter(Boolean).join(', ');
      const locality = [a.city, a.provinceCode || a.province, a.zip].filter(Boolean).join(' ');
      const mapsQuery = encodeURIComponent([loc.name, street, locality].filter(Boolean).join(' '));
      // Design's top-right slot is a DISTANCE ("0.8km"). It only exists once the shopper
      // has given us an origin to measure from; before that the pickup lead time is the
      // most useful thing that slot can honestly carry.
      const meta = distanceLabel(distanceKm(origin, a), d.distance) || node.pickUpTime || a.city || '';

      const warehouse = d.warehouses.has(String(loc.name || '').trim().toLowerCase());

      const li = document.createElement('li');
      li.className = 'fis-drawer__store';
      li.setAttribute('data-store', '');
      li.dataset.handle = loc.id || '';
      li.innerHTML = `
        <div class="fis-drawer__store-head">
          <p class="fis-drawer__store-name">${esc(loc.name)}</p>
          <span class="fis-drawer__store-meta" data-store-meta>${esc(meta)}</span>
          <span class="fis-drawer__store-flag" data-store-flag hidden>${esc(d.yourStore)}</span>
        </div>
        ${street ? `<p class="fis-drawer__store-address">${esc(street)}</p>` : ''}
        ${
          /* Design (14188:50183-50188) draws BOTH rows on every store: they are two
             independent facts, not two states of one fact. "On display" is about the
             showroom floor; "Pickup available" is about click & collect readiness. An
             either/or read them as mutually exclusive, which they are not.

             The one exception is a WAREHOUSE: it holds stock for pickup but has no
             showroom floor, so the "On display" row is a false claim there and is
             dropped. The pickup row stays. */ ''
        }
        <ul class="fis-drawer__status">
          ${
            warehouse
              ? ''
              : `<li class="fis-drawer__status-row">
            <span class="fis-drawer__dot fis-drawer__dot--display"></span>
            <span>${esc(d.onDisplay)}</span>
          </li>`
          }
          <li class="fis-drawer__status-row">
            <span class="fis-drawer__dot fis-drawer__dot--pickup"></span>
            <span>${esc(d.pickupLabel)}${
              d.pickupNote ? `<span class="fis-drawer__status-note">${esc(d.pickupNote)}</span>` : ''
            }</span>
          </li>
        </ul>
        <div class="fis-drawer__actions">
          <a class="fis-drawer__link" href="https://www.google.com/maps/search/?api=1&query=${mapsQuery}" target="_blank" rel="noopener">${esc(d.directions)}</a>
          ${a.phone ? `<a class="fis-drawer__link" href="tel:${esc(String(a.phone).replace(/\s/g, ''))}">${esc(phoneLabel(a.phone))}</a>` : ''}
          <button type="button" class="fis-drawer__link fis-drawer__link--set" data-store-set>${esc(d.setStore)}</button>
        </div>
      `;
      return li;
    }

    /**
     * Re-query pickup availability and repaint.
     *
     * Shopify does the proximity sort via `near`, so there is no client-side ranking
     * here. An empty result is rendered as the design's empty state — it means no
     * location has local pickup enabled for this variant, which is a normal state and
     * must not read as an error.
     */
    async function hydrate(drawer, term) {
      const body = drawer.querySelector('.fis-drawer__body');
      const results = drawer.querySelector('[data-store-results]');
      const list = drawer.querySelector('[data-store-list]');
      const heading = results && results.querySelector('[data-store-heading]');
      if (!body || !results || !list) return;

      const handle = body.dataset.productHandle;
      const sa = api();
      if (!handle || !sa || !sa.configured) {
        // No token configured: stay silent rather than showing a broken list.
        results.hidden = true;
        return;
      }

      const seq = ++requestSeq;
      const out = await sa.availability(handle, origin, SHOW);
      if (seq !== requestSeq) return; // a newer query superseded this one

      if (!out.ok) {
        // Transport/scope failure. Keep the shopper-facing UI quiet, but surface the
        // scope case on the console so a misconfiguration is diagnosable.
        if (out.reason === 'denied') {
          console.warn(
            '[find-in-store] Storefront token is missing the ' +
              'unauthenticated_read_product_pickup_locations scope.'
          );
        }
        results.hidden = true;
        return;
      }

      const d = {
        yourStore: body.dataset.yourStore || '',
        onDisplay: body.dataset.onDisplay || '',
        pickupLabel: body.dataset.pickupLabel || '',
        pickupNote: body.dataset.pickupNote || '',
        directions: body.dataset.directions || '',
        setStore: body.dataset.setStore || '',
        distance: body.dataset.distance || '',
        warehouses: warehouseNames(body.dataset.warehouses),
      };

      list.textContent = '';
      out.stores.forEach((node) => list.appendChild(row(node, d)));

      // A saved store always leads the list.
      const mine = myStore();
      if (mine) {
        const saved = list.querySelector(`[data-handle="${CSS.escape(mine)}"]`);
        if (saved) list.insertBefore(saved, list.firstChild);
      }

      if (heading) {
        // The proximity heading ("Showrooms near X" / "All showrooms") is deliberately
        // NOT rendered - the design shows the list starting directly under the search
        // field, and each row now carries its own distance, which states the proximity
        // per store rather than once for the whole list.
        //
        // The element itself stays: it is the aria-live region that announces the
        // no-results case and the geolocation errors, which have no other channel.
        const typed = (term || '').trim();
        heading.textContent = out.stores.length
          ? ''
          : (body.dataset.emptyTemplate || '').replace(TERM_TOKEN, typed);
      }

      results.hidden = false;
      paintMine(drawer);
    }

    /**
     * Fetch and render type-ahead locality suggestions.
     *
     * One Google session token spans every keystroke plus the final resolution, so a
     * shopper typing "Newtown" costs ONE billable session rather than seven requests.
     * Minted lazily, cleared on selection.
     */
    async function suggest(drawer, term) {
      const list = drawer.querySelector('[data-store-suggestions]');
      const value = (term || '').trim();
      if (!list) return;

      const sa = api();
      if (!sa || !sa.geocodeConfigured || value.length < 2) {
        hideSuggestions(drawer);
        return;
      }

      if (!drawer.__fisSession) drawer.__fisSession = sa.newSession();

      const mine = ++suggestSeq;
      const out = await sa.suggest(value, drawer.__fisSession);
      if (mine !== suggestSeq) return;

      if (!out.ok || !out.suggestions.length) {
        hideSuggestions(drawer);
        return;
      }

      list.textContent = '';
      out.suggestions.forEach((sug, i) => {
        const li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        li.innerHTML = `
          <button type="button" class="fis-drawer__suggestion" role="option"
                  aria-selected="false" data-store-suggestion="${i}">
            ${esc(sug.label)}
          </button>
        `;
        list.appendChild(li);
      });
      drawer.__fisSuggestions = out.suggestions;
      list.hidden = false;
    }

    function hideSuggestions(drawer) {
      const list = drawer.querySelector('[data-store-suggestions]');
      if (!list) return;
      list.hidden = true;
      list.textContent = '';
      drawer.__fisSuggestions = null;
    }

    /**
     * Resolve a picked suggestion into an exact origin, then hydrate.
     *
     * Only a SELECTED suggestion sets a proximity origin — that is what guarantees the
     * "near X" heading refers to the place the shopper actually chose.
     */
    async function choose(drawer, index) {
      const sug = (drawer.__fisSuggestions || [])[index];
      const input = drawer.querySelector('input[name="find_in_store_postcode"]');
      if (!sug) return;

      hideSuggestions(drawer);
      if (input) {
        input.value = sug.label;
        toggleClear(input);
      }

      const sa = api();
      const mine = ++requestSeq;
      const out = await sa.place(sug.placeId, drawer.__fisSession);

      // The session ends at resolution; the next search mints a fresh token.
      drawer.__fisSession = null;
      if (mine !== requestSeq) return;

      if (out.ok && out.match) {
        origin = { latitude: out.match.latitude, longitude: out.match.longitude };
        originTerm = sug.label;
        try {
          localStorage.setItem(KEY, sug.label);
          localStorage.setItem(ORIGIN_KEY, JSON.stringify(origin));
        } catch (e) {
          /* private mode - the drawer still works, it just will not remember */
        }
      } else {
        // Resolution failed: fall back to the unsorted list rather than ranking by a
        // stale origin, which would silently point at the previous search.
        origin = null;
        originTerm = null;
      }
      hydrate(drawer, input ? input.value : sug.label);
    }

    /**
     * Search handler.
     *
     * Unlike the delivery drawer this never refuses to act — FIS ranks, it does not
     * price, so an unsorted list is an acceptable outcome where a wrong price is not:
     *   - exactly one suggestion open -> take it and sort by it
     *   - several open                -> prompt to pick, keep them visible
     *   - none                        -> hydrate unsorted under "All showrooms"
     */
    async function apply(drawer) {
      const input = drawer && drawer.querySelector('input[name="find_in_store_postcode"]');
      if (!input) return;
      const value = input.value.trim();
      const open = drawer.__fisSuggestions || [];

      if (open.length === 1) {
        await choose(drawer, 0);
        return;
      }

      if (open.length > 1) {
        const body = drawer.querySelector('.fis-drawer__body');
        const results = drawer.querySelector('[data-store-results]');
        const heading = results && results.querySelector('[data-store-heading]');
        if (results) results.hidden = false;
        if (heading && body) heading.textContent = body.dataset.chooseHelp || '';
        input.focus();
        return;
      }

      // Nothing to pick: show every showroom rather than geocoding free text, which is
      // exactly the silently-wrong-suburb case the suggestion flow exists to prevent.
      origin = null;
      originTerm = null;
      hydrate(drawer, value);
    }

    function toggleClear(input) {
      const clear = input.closest('.fis-drawer__field')?.querySelector('[data-store-clear]');
      if (clear) clear.hidden = !input.value.trim();
    }

    document.addEventListener('DOMContentLoaded', () => {
      const saved = localStorage.getItem(KEY);
      document.querySelectorAll('input[name="find_in_store_postcode"]').forEach((input) => {
        if (saved && !input.value) input.value = saved;
        toggleClear(input);
      });
      // Restore the proximity origin that goes with the remembered postcode, so the
      // distance column is populated on first open rather than only after a re-search.
      try {
        const stored = JSON.parse(localStorage.getItem(ORIGIN_KEY) || 'null');
        if (stored && Number.isFinite(stored.latitude) && Number.isFinite(stored.longitude)) {
          origin = stored;
          originTerm = saved || null;
        }
      } catch (e) {
        /* corrupt or unreadable - fall through to the unsorted list */
      }
      document.querySelectorAll('.fis-drawer').forEach(paintMine);
      // Restore the chosen store into the availability block without a network call.
      let savedName = null;
      try {
        savedName = localStorage.getItem(STORE_NAME_KEY);
      } catch (e) {
        savedName = null;
      }
      if (savedName) paintPickupBlock(savedName);
    });

    document.addEventListener('click', (event) => {
      const drawer = event.target.closest('.fis-drawer');
      if (!drawer) return;

      if (event.target.closest('[data-find-in-store-confirm]')) {
        apply(drawer);
        return;
      }

      const suggestion = event.target.closest('[data-store-suggestion]');
      if (suggestion) {
        choose(drawer, Number(suggestion.dataset.storeSuggestion));
        return;
      }

      const clear = event.target.closest('[data-store-clear]');
      if (clear) {
        origin = null;
        originTerm = null;
        drawer.__fisSession = null;
        try {
          // Drop the persisted origin too - keeping it would resurrect distances for a
          // postcode the shopper just cleared.
          localStorage.removeItem(ORIGIN_KEY);
          localStorage.removeItem(KEY);
        } catch (e) {
          /* private mode - nothing to clean up */
        }
        hideSuggestions(drawer);
        const input = drawer.querySelector('input[name="find_in_store_postcode"]');
        if (input) {
          input.value = '';
          toggleClear(input);
          input.focus();
        }
        hydrate(drawer, '');
        return;
      }

      const locate = event.target.closest('[data-store-locate]');
      if (locate) {
        const body = drawer.querySelector('.fis-drawer__body');
        const results = drawer.querySelector('[data-store-results]');
        const heading = results && results.querySelector('[data-store-heading]');
        const say = (msg) => {
          if (results) results.hidden = false;
          if (heading) heading.textContent = msg || '';
        };
        if (!navigator.geolocation) {
          say(body && body.dataset.unavailable);
          return;
        }
        locate.setAttribute('aria-busy', 'true');
        say(body && body.dataset.locating);
        // A pending suggestion list would be stale the moment real coordinates land.
        hideSuggestions(drawer);
        drawer.__fisSession = null;
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            locate.removeAttribute('aria-busy');
            // The shopper's real position beats any picked locality.
            origin = { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
            originTerm = null;
            try {
              localStorage.setItem(ORIGIN_KEY, JSON.stringify(origin));
              // The field is cleared below, so the remembered postcode no longer
              // describes this origin.
              localStorage.removeItem(KEY);
            } catch (e) {
              /* private mode - the position just will not persist */
            }
            const input = drawer.querySelector('input[name="find_in_store_postcode"]');
            if (input) {
              input.value = '';
              toggleClear(input);
            }
            hydrate(drawer, '');
          },
          (err) => {
            locate.removeAttribute('aria-busy');
            origin = null;
            originTerm = null;
            say(body && (err && err.code === 1 ? body.dataset.denied : body.dataset.unavailable));
          },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
        );
        return;
      }

      const set = event.target.closest('[data-store-set]');
      if (set) {
        const store = set.closest('[data-store]');
        if (store) {
          const name = store.querySelector('.fis-drawer__store-name')?.textContent.trim() || '';
          try {
            localStorage.setItem(STORE_KEY, store.dataset.handle);
            localStorage.setItem(STORE_NAME_KEY, name);
          } catch (e) {
            /* private mode - the choice just will not persist */
          }
          paintMine(drawer);
          paintPickupBlock(name);
        }
        return;
      }

      // A click anywhere else in the drawer dismisses an open suggestion list.
      if (!event.target.closest('.fis-drawer__field')) hideSuggestions(drawer);
    });

    // Debounced type-ahead. 250ms; the session token means a whole search is billed
    // once regardless of keystroke count.
    let debounce;
    document.addEventListener('input', (event) => {
      const input = event.target.closest('input[name="find_in_store_postcode"]');
      if (!input) return;
      const drawer = input.closest('.fis-drawer');
      if (!drawer) return;
      toggleClear(input);
      // Typing invalidates the picked origin - it no longer matches the field, and
      // keeping it would sort the list by the shopper's PREVIOUS suburb.
      if (originTerm && input.value.trim() !== originTerm) {
        origin = null;
        originTerm = null;
      }
      clearTimeout(debounce);
      debounce = setTimeout(() => suggest(drawer, input.value), 250);
    });

    document.addEventListener('keydown', (event) => {
      // Scope to the FIELD, not the input: arrowing into the list moves focus onto a
      // suggestion button, and keying off the input alone would strand the shopper
      // there with dead arrow keys.
      const field = event.target.closest('.fis-drawer__field');
      if (!field) return;
      const drawer = field.closest('.fis-drawer');
      if (!drawer) return;

      const options = [...drawer.querySelectorAll('[data-store-suggestion]')];

      // Arrow keys move through the list; Enter takes the highlighted option. Without
      // this the listbox is mouse-only, which fails keyboard and screen-reader use.
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && options.length) {
        event.preventDefault();
        const current = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
        const next =
          event.key === 'ArrowDown'
            ? Math.min(current + 1, options.length - 1)
            : Math.max(current - 1, 0);
        options.forEach((o, i) => o.setAttribute('aria-selected', String(i === next)));
        options[next].focus();
        return;
      }

      if (event.key === 'Escape') {
        hideSuggestions(drawer);
        const input = drawer.querySelector('input[name="find_in_store_postcode"]');
        if (input) input.focus();
        return;
      }

      if (event.key === 'Enter') {
        // On a suggestion button, let the native click fire - the click handler already
        // resolves it, and intercepting here would double-resolve.
        if (event.target.closest('[data-store-suggestion]')) return;
        event.preventDefault();
        const highlighted = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
        if (highlighted >= 0) {
          choose(drawer, highlighted);
          return;
        }
        apply(drawer);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-dropdown"] && !Shopify.designMode) return;
  try {
    class DropdownField extends HTMLElement {
    connectedCallback() {
      this.native = this.querySelector('[data-dropdown-native]');
      this.trigger = this.querySelector('[data-dropdown-trigger]');
      // NB: the field is deliberately NOT named `popover` -- HTMLElement now
      // ships a native `popover` accessor (Popover API) whose setter coerces
      // any assigned value to the string 'manual', which then crashes
      // `this.panel.hidden = ...` in connectedCallback before the
      // trigger/list listeners ever bind (found by the QA runtime probe).
      this.panel = this.querySelector('[data-dropdown-popover]');
      this.list = this.querySelector('[data-dropdown-list]');
      this.valueEl = this.querySelector('[data-dropdown-value]');
      this.emptyEl = this.querySelector('[data-dropdown-empty]');
      this.search = this.querySelector('.dropdown__search input');
      if (!this.trigger || !this.native || !this.list) return;

      this.multiple = this.hasAttribute('data-multiple');
      this.items = Array.from(this.querySelectorAll('.dropdown__item'));
      this.placeholder = this.valueEl ? this.valueEl.textContent.trim() : '';
      this.activeIndex = -1;
      this.typeahead = '';
      this.typeaheadTimer = null;

      this.classList.add('is-enhanced');
      this.trigger.hidden = false;
      this.panel.hidden = true;

      this.onDocClick = this.onDocClick.bind(this);
      this.trigger.addEventListener('click', () => this.toggle());
      this.trigger.addEventListener('keydown', (e) => this.onTriggerKey(e));
      this.list.addEventListener('keydown', (e) => this.onListKey(e));
      this.items.forEach((item, i) => {
        item.addEventListener('click', () => this.select(i));
        item.addEventListener('mousemove', () => this.setActive(i));
      });
      if (this.search) {
        this.search.addEventListener('input', () => this.filter(this.search.value));
        this.search.addEventListener('keydown', (e) => this.onSearchKey(e));
      }
    }

    get isOpen() {
      return this.getAttribute('data-state') === 'open';
    }

    open() {
      if (this.trigger.disabled) return;
      this.setAttribute('data-state', 'open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
      document.addEventListener('click', this.onDocClick);
      const focusTarget = this.search || this.list;
      const current = this.items.findIndex((i) => i.classList.contains('is-selected'));
      this.setActive(current > -1 ? current : this.firstVisible());
      window.requestAnimationFrame(() => focusTarget.focus());
    }

    close(returnFocus) {
      this.setAttribute('data-state', 'closed');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
      document.removeEventListener('click', this.onDocClick);
      if (returnFocus) this.trigger.focus();
    }

    toggle() {
      this.isOpen ? this.close(true) : this.open();
    }

    onDocClick(e) {
      if (!this.contains(e.target)) this.close(false);
    }

    firstVisible() {
      return this.items.findIndex((i) => !i.hidden);
    }

    setActive(index) {
      this.items.forEach((i) => i.classList.remove('is-active'));
      this.activeIndex = index;
      const item = this.items[index];
      if (item) {
        item.classList.add('is-active');
        this.list.setAttribute('aria-activedescendant', item.id);
        item.scrollIntoView({ block: 'nearest' });
      }
    }

    move(step) {
      const visible = this.items.map((i, idx) => (i.hidden ? -1 : idx)).filter((i) => i > -1);
      if (!visible.length) return;
      const pos = visible.indexOf(this.activeIndex);
      let next;
      if (step > 0) next = pos < 0 || pos === visible.length - 1 ? visible[0] : visible[pos + 1];
      else next = pos <= 0 ? visible[visible.length - 1] : visible[pos - 1];
      this.setActive(next);
    }

    select(index) {
      const item = this.items[index];
      if (!item) return;
      const value = item.getAttribute('data-value');
      if (this.multiple) {
        item.classList.toggle('is-selected');
        const on = item.classList.contains('is-selected');
        item.setAttribute('aria-selected', on ? 'true' : 'false');
        const opt = this.native.querySelector('option[value="' + this.escapeAttr(value) + '"]');
        if (opt) opt.selected = on;
      } else {
        this.items.forEach((i) => {
          i.classList.remove('is-selected');
          i.setAttribute('aria-selected', 'false');
        });
        item.classList.add('is-selected');
        item.setAttribute('aria-selected', 'true');
        this.native.value = value;
      }
      this.syncValueLabel();
      this.native.dispatchEvent(new Event('change', { bubbles: true }));
      if (!this.multiple) this.close(true);
    }

    syncValueLabel() {
      const chosen = this.items.filter((i) => i.classList.contains('is-selected'));
      if (this.valueEl) {
        this.valueEl.textContent = chosen.length
          ? chosen.map((i) => i.getAttribute('data-label')).join(', ')
          : this.placeholder;
      }
      if (chosen.length) {
        this.setAttribute('data-filled', '');
      } else {
        this.removeAttribute('data-filled');
      }
    }

    filter(term) {
      const q = term.trim().toLowerCase();
      let visible = 0;
      this.items.forEach((item) => {
        const match = item.getAttribute('data-label').toLowerCase().indexOf(q) > -1;
        item.hidden = q !== '' && !match;
        if (!item.hidden) visible += 1;
      });
      if (this.emptyEl) {
        if (visible === 0) {
          this.emptyEl.hidden = false;
          this.emptyEl.textContent = this.emptyEl.getAttribute('data-empty-template')
            ? this.emptyEl.getAttribute('data-empty-template').replace('__term__', term)
            : '';
        } else {
          this.emptyEl.hidden = true;
        }
      }
      this.setActive(this.firstVisible());
    }

    onTriggerKey(e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.open();
      }
    }

    onListKey(e) {
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); this.move(1); break;
        case 'ArrowUp': e.preventDefault(); this.move(-1); break;
        case 'Home': e.preventDefault(); this.setActive(this.firstVisible()); break;
        case 'End': e.preventDefault(); this.setActive(this.lastVisible()); break;
        case 'Enter':
        case ' ': e.preventDefault(); if (this.activeIndex > -1) this.select(this.activeIndex); break;
        case 'Escape': e.preventDefault(); this.close(true); break;
        case 'Tab': this.close(false); break;
        default: this.onTypeahead(e.key);
      }
    }

    onSearchKey(e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); this.list.focus(); this.move(1); }
      else if (e.key === 'Escape') { e.preventDefault(); this.close(true); }
      else if (e.key === 'Enter') { e.preventDefault(); if (this.activeIndex > -1) this.select(this.activeIndex); }
    }

    lastVisible() {
      for (let i = this.items.length - 1; i >= 0; i -= 1) if (!this.items[i].hidden) return i;
      return -1;
    }

    onTypeahead(key) {
      if (key.length !== 1) return;
      window.clearTimeout(this.typeaheadTimer);
      this.typeahead += key.toLowerCase();
      this.typeaheadTimer = window.setTimeout(() => { this.typeahead = ''; }, 500);
      const match = this.items.findIndex(
        (i) => !i.hidden && i.getAttribute('data-label').toLowerCase().indexOf(this.typeahead) === 0
      );
      if (match > -1) this.setActive(match);
    }

    escapeAttr(value) {
      return String(value).replace(/"/g, '\\"');
    }
  }

  if (!customElements.get('dropdown-field')) {
    customElements.define('dropdown-field', DropdownField);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', function (event) {
    var native = event.target;
    if (!native.classList || !native.classList.contains('input__native')) {
      return;
    }
    var wrapper = native.closest('.input');
    if (!wrapper) {
      return;
    }
    var counter = wrapper.querySelector('[data-input-count]');
    if (!counter) {
      return;
    }
    var template = counter.getAttribute('data-template') || '';
    counter.textContent = template.replace('__count__', native.value.length);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lookbook-hotspot-pin"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lookbook-hotspot-group')) {
    customElements.define(
      'lookbook-hotspot-group',
      class LookbookHotspotGroup extends HTMLElement {
        connectedCallback() {
          this.pinSelector = '.lookbook-hotspots__pin';
          this.onClick = this.onClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeydown);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('keydown', this.onKeydown);
          document.removeEventListener('click', this.onDocumentClick);
        }

        get pins() {
          return Array.from(this.querySelectorAll(this.pinSelector));
        }

        onClick(event) {
          const pin = event.target.closest(this.pinSelector);
          if (!pin || !this.contains(pin)) return;
          const isOpen = pin.getAttribute('aria-expanded') === 'true';
          this.closeAll();
          if (!isOpen) this.open(pin);
        }

        open(pin) {
          pin.setAttribute('aria-expanded', 'true');
          const popover = document.getElementById(pin.getAttribute('aria-controls'));
          if (popover) popover.hidden = false;
          document.addEventListener('click', this.onDocumentClick);
        }

        closeAll() {
          this.pins.forEach((pin) => {
            pin.setAttribute('aria-expanded', 'false');
            const popover = document.getElementById(pin.getAttribute('aria-controls'));
            if (popover) popover.hidden = true;
          });
          document.removeEventListener('click', this.onDocumentClick);
        }

        onKeydown(event) {
          if (event.key === 'Escape') {
            const openPin = this.pins.find((pin) => pin.getAttribute('aria-expanded') === 'true');
            this.closeAll();
            if (openPin) openPin.focus();
          }
        }

        onDocumentClick(event) {
          if (!this.contains(event.target)) this.closeAll();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-drawer"] && !Shopify.designMode) return;
  try {
    // Search / cart links inside the drawer: close the menu drawer so the
  // target drawer isn't stacked on top of it.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-close-menu-drawer]');
    if (!trigger) return;
    const drawer = trigger.closest('menu-drawer');
    if (drawer && typeof drawer.hide === 'function') drawer.hide();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["navigation"] && !Shopify.designMode) return;
  try {
    (function () {
    var OPEN = 'open';
    var CLOSED = 'closed';

    function panels(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-og-nav-panel]'));
    }

    function activate(root, key) {
      panels(root).forEach(function (panel) {
        var match = panel.getAttribute('data-og-nav-panel') === key;
        panel.hidden = !match;
        if (match) {
          panel.setAttribute('data-og-nav-active', '');
        } else {
          panel.removeAttribute('data-og-nav-active');
        }
      });

      root.querySelectorAll('[data-og-nav-push]').forEach(function (button) {
        button.setAttribute('aria-expanded', String(button.getAttribute('data-og-nav-push') === key));
      });
    }

    function focusables(scope) {
      return Array.prototype.slice
        .call(
          scope.querySelectorAll(
            'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
          )
        )
        .filter(function (el) {
          return el.offsetParent !== null;
        });
    }

    function emit(root, name, detail) {
      root.dispatchEvent(new CustomEvent('og-nav:' + name, { bubbles: true, detail: detail || {} }));
    }

    function open(root, opener) {
      root.removeAttribute('inert');
      root.setAttribute('data-state', OPEN);
      root.__ogNavOpener = opener || null;
      document.documentElement.style.overflow = 'hidden';
      activate(root, 'root');

      var first = focusables(root)[0];
      if (first) first.focus();

      emit(root, 'open');
    }

    function close(root) {
      root.setAttribute('data-state', CLOSED);
      root.setAttribute('inert', '');
      document.documentElement.style.overflow = '';
      activate(root, 'root');

      if (root.__ogNavOpener) {
        root.__ogNavOpener.focus();
        root.__ogNavOpener = null;
      }

      emit(root, 'close');
    }

    function trap(event, root) {
      if (event.key !== 'Tab') return;

      var items = focusables(root);
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-og-nav-toggle]');
      if (toggle) {
        var target = document.getElementById(toggle.getAttribute('data-og-nav-toggle'));
        if (target) {
          event.preventDefault();
          if (target.getAttribute('data-state') === OPEN) {
            close(target);
          } else {
            open(target, toggle);
          }
        }
        return;
      }

      var root = event.target.closest('[data-og-nav]');
      if (!root) return;

      if (event.target.closest('[data-og-nav-close]') || event.target.closest('[data-og-nav-scrim]')) {
        event.preventDefault();
        close(root);
        return;
      }

      var push = event.target.closest('[data-og-nav-push]');
      if (push) {
        event.preventDefault();
        var key = push.getAttribute('data-og-nav-push');
        activate(root, key);
        var heading = root.querySelector('[data-og-nav-panel="' + key + '"] [data-og-nav-back]');
        if (heading) heading.focus();
        emit(root, 'push', { panel: key });
        return;
      }

      if (event.target.closest('[data-og-nav-back]')) {
        event.preventDefault();
        activate(root, 'root');
        emit(root, 'pop');
      }
    });

    document.addEventListener('keydown', function (event) {
      var root = document.querySelector('[data-og-nav][data-state="open"]');
      if (!root) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close(root);
        return;
      }

      trap(event, root);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pcard-color-swatch"] && !Shopify.designMode) return;
  try {
    /* Colour chips swap the card in place instead of navigating: the shopper
     stays on the grid and the card becomes the sibling product -- image, links,
     title and price. The chip remains an <a href>, so this is an enhancement
     layered over working navigation, and any failure below falls through to it.

     Delegated once per document rather than bound per card: a PLP renders up to
     ~60 chips, and facet/pagination re-renders replace card markup wholesale,
     which would strand per-node listeners. */
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('.swatches--product-card a');
    if (!chip) return;

    const item = chip.closest('[data-sibling]');
    const card = chip.closest('.product-card');
    if (!item || !card) return;

    const url = item.dataset.siblingUrl;
    if (!url) return;

    event.preventDefault();

    const image = card.querySelector('.product-card__image--main img, .product-card__image img');
    if (image && item.dataset.siblingImage) {
      image.srcset = '';
      image.src = item.dataset.siblingImage;
    }

    // Every link in the card points at the product, including the title, the
    // media wrapper and the quick-add trigger when it is a plain PDP link.
    card.querySelectorAll('a[href]').forEach((link) => {
      if (link.closest('.swatches--product-card')) return;
      link.href = url;
    });

    const title = card.querySelector('.product-card__title a, .product-card__title');
    if (title && item.dataset.siblingTitle) title.textContent = item.dataset.siblingTitle;

    const price = card.querySelector('.f-price');
    if (price && item.dataset.siblingPrice) {
      const compare = item.dataset.siblingCompare;
      price.classList.toggle('f-price--on-sale', Boolean(compare));
      price.classList.toggle('f-price--vip', Boolean(compare));
      price.querySelectorAll('.f-price-item--regular, .f-price-item--sale').forEach((node) => {
        node.textContent = item.dataset.siblingPrice;
      });
      price.querySelectorAll('.f-price-item--compare').forEach((node) => {
        node.textContent = compare || '';
      });
    }

    card.querySelectorAll('.swatches--product-card a[aria-current]').forEach((node) => {
      node.removeAttribute('aria-current');
    });
    chip.setAttribute('aria-current', 'true');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information-blocks"] && !Shopify.designMode) return;
  try {
    // Collapsed colour-row expander: the "Choose from N colours" link is the
  // sibling colour row's collapsed presentation (Figma 11357:99104).
  // Delegated once; survives product-info section re-renders.
  if (!window.__siblingExpandBound) {
    window.__siblingExpandBound = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-sibling-expand]');
      if (!trigger) return;
      const target = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!target) return;
      const expand = target.hidden;
      target.hidden = !expand;
      trigger.setAttribute('aria-expanded', expand ? 'true' : 'false');
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-stock-notify"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-stock-notify')) {
    customElements.define(
      'product-stock-notify',
      class ProductStockNotify extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          if (!this.form) return;
          this._onSubmit = this.onSubmit.bind(this);
          this.form.addEventListener('submit', this._onSubmit);
        }
        disconnectedCallback() {
          if (this.form) this.form.removeEventListener('submit', this._onSubmit);
        }
        onSubmit(event) {
          event.preventDefault();
          const submit = this.querySelector('.stock-notify__submit[type="submit"]');
          const errorEl = this.querySelector('[data-notify-error]');
          if (errorEl) errorEl.hidden = true;
          if (submit) {
            submit.classList.add('btn--loading');
            submit.setAttribute('disabled', 'disabled');
          }
          fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            headers: { Accept: 'text/html' },
          })
            .then((response) => {
              if (!response.ok) throw new Error('notify-failed');
              this.showSuccess();
            })
            .catch(() => {
              if (errorEl) errorEl.hidden = false;
            })
            .finally(() => {
              if (submit) {
                submit.classList.remove('btn--loading');
                submit.removeAttribute('disabled');
              }
            });
        }
        showSuccess() {
          this.querySelectorAll('[data-notify-pending]').forEach((el) => (el.hidden = true));
          this.querySelectorAll('[data-notify-success]').forEach((el) => (el.hidden = false));
          const status = this.querySelector('[data-notify-status]');
          const successBanner = this.querySelector('[data-notify-success].stock-notify__banner');
          if (status && successBanner) status.textContent = successBanner.textContent.trim();
          const productInfo = this.closest('product-info');
          const marker = this.getAttribute('data-state-marker');
          if (productInfo && marker) {
            const states = (productInfo.getAttribute('data-state') || '').split(/\s+/).filter(Boolean);
            if (!states.includes(marker)) states.push(marker);
            productInfo.setAttribute('data-state', states.join(' '));
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    /* Stepping owner for <quantity-selector>. The inherited theme.js class
     binds a click handler that reads `input.quantity` (a property that does
     not exist on HTMLInputElement), so its stepping is a no-op; this single
     guarded document-level listener is the one functional owner of the
     trigger. Delegation survives Section Rendering API swaps (quick-add
     drawer content is injected after load). */
  if (!window.__ogQuantitySelectorStepFix) {
    window.__ogQuantitySelectorStepFix = true;

    var ogQtySyncBounds = function (root) {
      var input = root.querySelector('.quantity__input');
      if (!input) return;
      var value = parseFloat(input.value);
      var min = input.min === '' ? null : parseFloat(input.min);
      var max = input.max === '' ? null : parseFloat(input.max);
      var minus = root.querySelector('.quantity__button[name="minus"]');
      var plus = root.querySelector('.quantity__button[name="plus"]');
      if (minus) minus.toggleAttribute('disabled', min !== null && value <= min);
      if (plus) plus.toggleAttribute('disabled', max !== null && value >= max);
    };

    document.addEventListener('click', function (event) {
      var button = event.target.closest('quantity-selector .quantity__button');
      if (!button || button.disabled) return;
      var root = button.closest('quantity-selector');
      var input = root.querySelector('.quantity__input');
      if (!input) return;
      var previous = input.value;
      if (button.name === 'plus') {
        input.stepUp();
      } else {
        input.stepDown();
      }
      ogQtySyncBounds(root);
      if (input.value !== previous) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.addEventListener('change', function (event) {
      if (!event.target || !event.target.closest) return;
      var input = event.target.closest('quantity-selector .quantity__input');
      if (!input) return;
      if (input.value === '') input.value = input.min || '1';
      var min = input.min === '' ? null : parseFloat(input.min);
      var max = input.max === '' ? null : parseFloat(input.max);
      var value = parseFloat(input.value);
      if (min !== null && value < min) input.value = min;
      if (max !== null && value > max) input.value = max;
      ogQtySyncBounds(input.closest('quantity-selector'));
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-picker"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('f-quantity-picker')) {
    window.customElements.define(
      'f-quantity-picker',
      class FQuantityPicker extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;

          this.input = this.querySelector('[data-quantity-input]');
          if (!this.input) return;

          this.minusEl = this.querySelector('[data-quantity-minus]');
          this.plusEl = this.querySelector('[data-quantity-plus]');

          this.onClick = this.onClick.bind(this);
          this.onCommit = this.onCommit.bind(this);

          this.addEventListener('click', this.onClick);
          this.input.addEventListener('change', this.onCommit);
          this.input.addEventListener('blur', this.onCommit);

          this.bound = true;

          // Reconcile the server-rendered markup without announcing a change.
          this.apply(this.read(), false);
        }

        disconnectedCallback() {
          if (!this.bound) return;

          this.removeEventListener('click', this.onClick);
          this.input.removeEventListener('change', this.onCommit);
          this.input.removeEventListener('blur', this.onCommit);

          // Resetting the flag is what lets a node moved by a Section Rendering
          // swap rebind itself when it reconnects.
          this.bound = false;
        }

        get min() {
          return this.toInt(this.dataset.min, 1);
        }

        get max() {
          if (this.dataset.max === undefined) return null;
          return this.toInt(this.dataset.max, null);
        }

        get step() {
          const parsed = this.toInt(this.dataset.step, 1);
          return parsed && parsed > 0 ? parsed : 1;
        }

        toInt(raw, fallback) {
          const parsed = parseInt(raw, 10);
          return Number.isNaN(parsed) ? fallback : parsed;
        }

        read() {
          return this.toInt(this.input.value, this.min);
        }

        clamp(candidate) {
          const min = this.min;
          const max = this.max;
          const step = this.step;

          let next = Number.isFinite(candidate) ? candidate : min;

          // Snap onto the step grid measured from min, so a typed 7 with a
          // step of 5 and a min of 1 resolves to 6, not to 7.
          next = min + Math.round((next - min) / step) * step;

          if (next < min) next = min;

          if (max !== null && next > max) {
            const capped = min + Math.floor((max - min) / step) * step;
            next = capped < min ? min : capped;
          }

          return next;
        }

        setDisabled(el, off) {
          if (!el) return;
          el.disabled = this.hasAttribute('data-disabled') ? true : off;
        }

        flag(name, on) {
          if (on) {
            this.setAttribute(name, '');
          } else {
            this.removeAttribute(name);
          }
        }

        apply(candidate, announce) {
          const previous = this.read();
          const value = this.clamp(candidate);
          const changed = String(this.input.value) !== String(value);

          if (changed) this.input.value = String(value);

          const min = this.min;
          const max = this.max;
          const atMin = value <= min;
          const atMax = max !== null && value >= max;

          this.setDisabled(this.minusEl, atMin);
          this.setDisabled(this.plusEl, atMax);
          this.flag('data-at-min', atMin);
          this.flag('data-at-max', atMax);

          if (!announce || !changed) return;

          this.input.dispatchEvent(new Event('input', { bubbles: true }));
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
          this.dispatchEvent(
            new CustomEvent('quantity:change', {
              bubbles: true,
              composed: true,
              detail: {
                value: value,
                previous: previous,
                min: min,
                max: max,
                step: this.step,
                name: this.input.name,
              },
            })
          );
        }

        onClick(event) {
          const trigger = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
          if (!trigger || !this.contains(trigger) || trigger.disabled) return;

          const isMinus = trigger.hasAttribute('data-quantity-minus');
          this.apply(this.read() + (isMinus ? -this.step : this.step), true);
        }

        onCommit() {
          this.apply(this.read(), true);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slider-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('f-slider-controls')) {
    class FSliderControls extends HTMLElement {
      static get observedAttributes() {
        return ['data-active', 'data-count'];
      }

      constructor() {
        super();
        this.bound = false;
        this.onClick = this.onClick.bind(this);
      }

      get count() {
        return parseInt(this.dataset.count, 10) || 0;
      }

      get activeIndex() {
        return parseInt(this.dataset.active, 10) || 0;
      }

      set activeIndex(index) {
        this.dataset.active = String(index);
      }

      get loops() {
        return this.dataset.loop === 'true';
      }

      connectedCallback() {
        if (!this.bound) {
          this.addEventListener('click', this.onClick);
          this.bound = true;
        }
        this.render();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.bound = false;
      }

      attributeChangedCallback() {
        if (!this.bound) return;
        this.render();
      }

      fill(template, values) {
        if (!template) return '';
        return values.reduce(function (text, value, position) {
          return text.split('%' + (position + 1)).join(String(value));
        }, template);
      }

      render() {
        const total = this.count;
        if (total < 1) return;

        let index = this.activeIndex;
        if (index < 0) index = 0;
        if (index > total - 1) index = total - 1;

        const indicators = this.querySelectorAll('[data-slider-goto]');
        indicators.forEach(function (indicator) {
          const position = parseInt(indicator.dataset.sliderGoto, 10);
          if (position === index) {
            indicator.setAttribute('aria-current', 'true');
          } else {
            indicator.removeAttribute('aria-current');
          }
        });

        const prev = this.querySelector('[data-slider-prev]');
        const next = this.querySelector('[data-slider-next]');
        this.setDisabled(prev, !this.loops && index === 0);
        this.setDisabled(next, !this.loops && index === total - 1);

        const number = index + 1;
        const counterText = this.querySelector('[data-slider-counter-text]');
        const counterVisual = this.querySelector('[data-slider-counter-visual]');
        const readable = this.fill(this.dataset.labelCounter, [number, total]);

        if (counterText) counterText.textContent = readable;
        if (counterVisual) {
          counterVisual.textContent = this.pad(number) + ' / ' + this.pad(total);
        }

        const track = this.querySelector('[data-slider-progress]');
        if (track) {
          track.setAttribute('aria-valuemax', String(total));
          track.setAttribute('aria-valuenow', String(number));
          if (readable) track.setAttribute('aria-valuetext', readable);
        }

        const progressFill = this.querySelector('[data-slider-progress-fill]');
        if (progressFill) {
          const percent = (number * 100) / total;
          progressFill.style.setProperty('--f-slider-controls-progress', percent + '%');
        }
      }

      pad(value) {
        return value < 10 ? '0' + value : String(value);
      }

      setDisabled(element, disabled) {
        if (!element) return;
        if (element.tagName === 'BUTTON') {
          element.disabled = disabled;
        } else {
          element.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }
      }

      isBlocked(element) {
        return element.disabled === true || element.getAttribute('aria-disabled') === 'true';
      }

      navigate(action, index) {
        this.dispatchEvent(
          new CustomEvent('slider-controls:navigate', {
            bubbles: true,
            composed: true,
            detail: { action: action, index: index },
          })
        );
      }

      onClick(event) {
        const indicator = event.target.closest('[data-slider-goto]');
        if (indicator && this.contains(indicator)) {
          this.navigate('goto', parseInt(indicator.dataset.sliderGoto, 10));
          return;
        }

        const prev = event.target.closest('[data-slider-prev]');
        if (prev && this.contains(prev)) {
          if (this.isBlocked(prev)) return;
          this.navigate('prev', -1);
          return;
        }

        const next = event.target.closest('[data-slider-next]');
        if (next && this.contains(next)) {
          if (this.isBlocked(next)) return;
          this.navigate('next', -1);
        }
      }
    }

    customElements.define('f-slider-controls', FSliderControls);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sort-drawer"] && !Shopify.designMode) return;
  try {
    class SortDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmit);
    }

    onSubmit(event) {
      // The owned form exists only to give the radios a form owner, so that
      // this instance cannot join the document-wide sort_by group. It has no
      // action and no submit control, so nothing should ever reach here. This
      // is a guard against a future consumer adding one, not a code path.
      event.preventDefault();
    }

    onChange(event) {
      if (!this.contains(event.target)) return;

      // The sort element's own listener sits below this one, so by the time
      // this runs the submit has already been issued. Closing is all that is
      // left to do, and doing it here rather than there keeps one owner per
      // behaviour.
      const drawer = this.closest('drawer-component');
      if (!drawer || typeof drawer.hide !== 'function') return;

      drawer.hide();
    }
  }

  if (!customElements.get('sort-drawer')) {
    customElements.define('sort-drawer', SortDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sort"] && !Shopify.designMode) return;
  try {
    class SortOptions extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange(event) {
      // Inside a facet form the form's own change handler already rebuilds the
      // URL and re-renders. Doing it here as well would fire two requests for
      // one click, so this path stops at the guard.
      if (this.closest('form[is="facet-form"]')) return;

      const form = document.querySelector('form[is="facet-form"]');
      if (!form || typeof form.renderSection !== 'function') return;
      if (!window.FoxTheme || !FoxTheme.utils || !FoxTheme.utils.getSectionId) return;

      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(form));
      url.searchParams.delete('page');

      form.renderSection(url.toString(), event);
    }
  }

  if (!customElements.get('sort-options')) {
    customElements.define('sort-options', SortOptions);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    // Reveals the bar once the PDP's own buy box has left the viewport. That is the
  // whole element now.
  //
  // NOTHING SYNCS A VARIANT ANY MORE. Every product in this catalogue is single
  // variant, so the bar's hidden `id` input is Liquid-bound and immutable. The
  // `variantChange` subscription this element used to run -- and the price, media
  // and quantity-rule resync it drove, plus the deferred-subscribe dance needed
  // because `theme.js` loads `defer` while this block is inlined -- had no
  // selection left to follow. A swatch click is a full page navigation and the bar
  // re-renders server-side against the new product.
  //
  // WHY NOT REUSE THE INHERITED `sticky-atc-bar` ELEMENT
  // That element publishes a foot-reserve height and drives a body class the
  // inherited bar's own CSS needs; this bar's positioning is entirely local. The
  // two remain separate, only one is enabled on a route.
  if (!customElements.get('sticky-atc')) {
    customElements.define(
      'sticky-atc',
      class StickyAtc extends HTMLElement {
        connectedCallback() {
          // `data-force-visible` skips the observer: the specimen forces the bar
          // open, so it must not also be driven by an observer watching a buy box
          // that is not on the page.
          this.target = this.hasAttribute('data-force-visible')
            ? null
            : document.querySelector(this.dataset.observe);

          // No buy box on the route (a specimen, or a section rendered outside
          // a PDP) means there is nothing to scroll past, so the bar stays down
          // rather than being permanently pinned over the page.
          if (this.target) {
            this.observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  this.classList.toggle('f-sticky-atc--visible', !entry.isIntersecting);
                });
              },
              { rootMargin: '0px', threshold: 0 }
            );
            this.observer.observe(this.target);
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('f-tabs-nav')) {
    class FTabsNav extends HTMLElement {
      constructor() {
        super();
        this.tabs = [];
        this.bound = false;
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (this.tabs.length === 0) return;

        if (!this.bound) {
          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeydown);
          this.bound = true;
        }

        const selected = this.tabs.findIndex(function (tab) {
          return tab.getAttribute('aria-selected') === 'true';
        });
        this.select(selected < 0 ? 0 : selected, false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.bound = false;
      }

      panelFor(tab) {
        const id = tab.getAttribute('aria-controls');
        return id ? document.getElementById(id) : null;
      }

      select(index, userInitiated) {
        const target = this.tabs[index];
        if (!target) return;

        this.tabs.forEach(function (tab, position) {
          const isActive = position === index;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');

          const panel = this.panelFor(tab);
          if (!panel) return;
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        }, this);

        if (!userInitiated) return;

        target.focus();
        this.keepVisible(target);
        this.dispatchEvent(
          new CustomEvent('tabs:changed', {
            bubbles: true,
            detail: { index: index, tab: target, panel: this.panelFor(target) },
          })
        );
      }

      keepVisible(tab) {
        const list = tab.parentElement;
        if (!list || list.scrollWidth <= list.clientWidth) return;

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const left = tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2;
        list.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
      }

      onClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;

        const index = this.tabs.indexOf(tab);
        if (index < 0) return;
        this.select(index, true);
      }

      onKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;

        const current = this.tabs.indexOf(tab);
        if (current < 0) return;

        const total = this.tabs.length;
        const rtl = window.getComputedStyle(this).direction === 'rtl';
        const forward = rtl ? 'ArrowLeft' : 'ArrowRight';
        const backward = rtl ? 'ArrowRight' : 'ArrowLeft';
        let next = -1;

        if (event.key === forward) {
          next = (current + 1) % total;
        } else if (event.key === backward) {
          next = (current - 1 + total) % total;
        } else if (event.key === 'Home') {
          next = 0;
        } else if (event.key === 'End') {
          next = total - 1;
        } else if (event.key === 'Enter' || event.key === ' ') {
          next = current;
        } else {
          return;
        }

        event.preventDefault();
        this.select(next, true);
      }
    }

    customElements.define('f-tabs-nav', FTabsNav);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast-banner"] && !Shopify.designMode) return;
  try {
    class ToastBanner extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('.toast-banner__template');
      this.defaultDuration = parseInt(this.dataset.duration, 10);
      if (isNaN(this.defaultDuration)) {
        this.defaultDuration = 4000;
      }
      this.defaultActionLabel = this.dataset.defaultActionLabel || '';

      this._onShow = (event) => {
        this.show(event.detail || {});
      };
      document.addEventListener('toast:show', this._onShow);

      if (!window.showToast) {
        window.showToast = function (options) {
          const region = document.querySelector('toast-banner');
          if (region) {
            return region.show(options || {});
          }
          return null;
        };
      }

      const initial = this.querySelector('.toast-banner__initial');
      if (initial) {
        try {
          this.show(JSON.parse(initial.textContent));
        } catch (error) {
          /* malformed initial payload: skip */
        }
        initial.remove();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('toast:show', this._onShow);
    }

    show(options) {
      if (!this.template) {
        return null;
      }
      const opts = options || {};
      const status = opts.status || 'default';
      const urgent = status === 'warning' || status === 'error';

      const node = this.template.content.firstElementChild.cloneNode(true);
      node.classList.add('toast--' + status);
      node.setAttribute('role', urgent ? 'alert' : 'status');
      node.setAttribute('aria-live', urgent ? 'assertive' : 'polite');

      const headingEl = node.querySelector('.toast__heading');
      const subEl = node.querySelector('.toast__subcopy');
      if (opts.heading) {
        headingEl.textContent = opts.heading;
      } else {
        headingEl.remove();
      }
      if (opts.subcopy) {
        subEl.textContent = opts.subcopy;
      } else {
        subEl.remove();
      }

      const actionWrap = node.querySelector('.toast__action');
      const label = opts.action_label || opts.actionLabel;
      if (label) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'toast__action-button';
        button.textContent = label;
        button.addEventListener('click', () => {
          node.dispatchEvent(new CustomEvent('toast:action', { bubbles: true, detail: opts }));
          this.dismiss(node, 'action');
        });
        actionWrap.appendChild(button);
      } else {
        actionWrap.remove();
      }

      this.appendChild(node);

      let duration = parseInt(opts.duration, 10);
      if (isNaN(duration)) {
        duration = this.defaultDuration;
      }
      node._duration = duration;

      requestAnimationFrame(() => {
        node.removeAttribute('hidden');
        requestAnimationFrame(() => {
          node.classList.add('is-visible');
        });
      });

      this._arm(node);
      node.addEventListener('mouseenter', () => this._clear(node));
      node.addEventListener('mouseleave', () => this._arm(node));
      node.addEventListener('focusin', () => this._clear(node));
      node.addEventListener('focusout', () => this._arm(node));

      return node;
    }

    _arm(node) {
      this._clear(node);
      if (node._duration > 0 && !node._dismissed) {
        node._timer = window.setTimeout(() => this.dismiss(node, 'timeout'), node._duration);
      }
    }

    _clear(node) {
      if (node._timer) {
        window.clearTimeout(node._timer);
        node._timer = null;
      }
    }

    dismiss(node, reason) {
      if (node._dismissed) {
        return;
      }
      node._dismissed = true;
      this._clear(node);
      node.classList.remove('is-visible');
      node.dispatchEvent(new CustomEvent('toast:dismiss', { bubbles: true, detail: { reason: reason } }));

      const remove = () => {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      };

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        remove();
        return;
      }

      let done = false;
      const onEnd = () => {
        if (done) {
          return;
        }
        done = true;
        node.removeEventListener('transitionend', onEnd);
        remove();
      };
      node.addEventListener('transitionend', onEnd);
      window.setTimeout(onEnd, 500);
    }
  }

  if (!customElements.get('toast-banner')) {
    customElements.define('toast-banner', ToastBanner);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast"] && !Shopify.designMode) return;
  try {
    const TOAST_STACK_CLASS = 'toast-banner-stack';

  class ToastBanner extends HTMLElement {
    static stack() {
      let el = document.querySelector('.' + TOAST_STACK_CLASS);
      if (!el) {
        el = document.createElement('div');
        // `no-empty` keeps the stack alive between toasts; see the stylesheet.
        el.className = TOAST_STACK_CLASS + ' no-empty';
        document.body.appendChild(el);
      }
      return el;
    }

    constructor() {
      super();
      this.initialised = false;
      this.timer = null;
      this.remaining = 0;
      this.startedAt = 0;
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.pause = this.pause.bind(this);
      this.resume = this.resume.bind(this);
    }

    connectedCallback() {
      // Moving into the stack re-fires connectedCallback, so this guard is load
      // bearing rather than defensive.
      if (this.initialised) {
        return;
      }
      this.initialised = true;

      if (this.hasAttribute('data-floating')) {
        const stack = ToastBanner.stack();
        if (this.parentElement !== stack) {
          stack.appendChild(this);
        }
      }

      this.announce();

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('pointerenter', this.pause);
      this.addEventListener('pointerleave', this.resume);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.resume);

      this.remaining = parseInt(this.dataset.duration || '0', 10) || 0;
      this.resume();
    }

    disconnectedCallback() {
      this.clear();
    }

    // A live region populated in the same mutation that creates it is not
    // announced, so the copy is written on the following frame instead.
    announce() {
      const live = this.querySelector('[data-toast-announce]');
      if (!live) {
        return;
      }
      const parts = [];
      const title = this.querySelector('.toast-banner__title');
      const detail = this.querySelector('.toast-banner__detail');
      if (title) {
        parts.push(title.textContent.trim());
      }
      if (detail) {
        parts.push(detail.textContent.trim());
      }
      const message = parts.join('. ');
      if (!message) {
        return;
      }
      window.requestAnimationFrame(function () {
        live.textContent = message;
      });
    }

    clear() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }

    pause() {
      if (!this.timer) {
        return;
      }
      this.clear();
      this.remaining = this.remaining - (Date.now() - this.startedAt);
      if (this.remaining < 1) {
        this.remaining = 1;
      }
    }

    resume() {
      if (this.timer) {
        return;
      }
      if (this.remaining <= 0) {
        return;
      }
      if (this.dataset.state === 'leave') {
        return;
      }
      this.startedAt = Date.now();
      const self = this;
      this.timer = window.setTimeout(function () {
        self.timer = null;
        self.dismiss();
      }, this.remaining);
    }

    onClick(event) {
      const trigger = event.target.closest('[data-toast-dismiss]');
      if (!trigger) {
        return;
      }
      event.preventDefault();
      this.dismiss();
    }

    onKeydown(event) {
      if (event.key !== 'Escape') {
        return;
      }
      event.stopPropagation();
      this.dismiss();
    }

    // Read the transition back off the element rather than duplicating the
    // token value, so prefers-reduced-motion (transition: none) collapses the
    // removal delay to zero without a second code path.
    leaveDelay() {
      const raw = window.getComputedStyle(this).transitionDuration || '0s';
      const first = raw.split(',')[0].trim();
      const value = parseFloat(first) || 0;
      if (first.indexOf('ms') > -1) {
        return Math.round(value);
      }
      return Math.round(value * 1000);
    }

    dismiss() {
      if (this.dataset.state === 'leave') {
        return;
      }
      this.clear();
      this.remaining = 0;
      this.dataset.state = 'leave';
      const self = this;
      window.setTimeout(function () {
        self.remove();
      }, this.leaveDelay());
    }
  }

  if (!window.customElements.get('toast-banner')) {
    window.customElements.define('toast-banner', ToastBanner);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tooltip"] && !Shopify.designMode) return;
  try {
    (function () {
    function forEachOpen(callback) {
      var open = document.querySelectorAll('.tooltip-wrap:hover, .tooltip-wrap:focus-within');
      Array.prototype.forEach.call(open, callback);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      forEachOpen(function (wrap) {
        wrap.classList.add('is-dismissed');
        if (typeof wrap.blur === 'function') wrap.blur();
      });
    });

    document.addEventListener('mouseleave', function (event) {
      var target = event.target;
      if (target && target.classList && target.classList.contains('tooltip-wrap')) {
        target.classList.remove('is-dismissed');
      }
    }, true);

    document.addEventListener('focusout', function (event) {
      var wrap = event.target.closest ? event.target.closest('.tooltip-wrap') : null;
      if (wrap) wrap.classList.remove('is-dismissed');
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vip-pricing-gate"] && !Shopify.designMode) return;
  try {
    // Dismissal lasts the browsing session: a shopper who closes this has said no
  // to the offer for this visit, and gets asked again next time they come back.
  // sessionStorage rather than a localStorage timestamp is what makes that the
  // browser's definition of a session rather than one this file invents -- it
  // survives navigation and reloads and clears itself when the tab closes, so
  // there is no window to pick and nothing to expire.
  //
  // Note it is scoped to the TAB, not the browser: a second tab is a second
  // session and shows the card again.
  //
  // The section's "Remember dismissal" setting turns this off entirely, in
  // which case the close button lasts for the page view only and nothing is
  // stored -- the saved key is not even read, so a shopper who dismissed it
  // while the setting was on still sees the card once the merchant turns it off.
  //
  // The card ships with `hidden` and is revealed here rather than shipping
  // visible and being hidden on dismissal. With JS off it therefore never
  // appears, which is the right failure: the close button would not work
  // either, leaving an undismissable card pinned over the page.
  const VIP_GATE_KEY = 'olive-grove:vip-gate-dismissed';

  class VipPricingGate extends HTMLElement {
    connectedCallback() {
      // Earlier builds kept the dismissal in localStorage, first as '1' forever
      // and then as a 24h timestamp. Nothing reads that key now, so clear it
      // rather than leave a dead entry in every past visitor's browser.
      localStorage.removeItem(VIP_GATE_KEY);

      const remember = this.dataset.remember !== 'false';
      if (remember && sessionStorage.getItem(VIP_GATE_KEY) === '1') return;
      this.classList.remove('hidden');
      const dismiss = this.querySelector('[data-vip-gate-dismiss]');
      if (dismiss) {
        dismiss.addEventListener('click', () => {
          if (remember) sessionStorage.setItem(VIP_GATE_KEY, '1');
          this.classList.add('hidden');
        });
      }
    }
  }
  if (!customElements.get('vip-pricing-gate')) {
    customElements.define('vip-pricing-gate', VipPricingGate);
  }
  } catch(e) { console.error(e); }
})();

})();
